import React, { useEffect, useState } from "react";
import { Button, Col, Nav, Row, Tab, Modal, Spinner, Accordion, Table, Form, } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import pencil_ from "../../../assets/images/icons/pencil_.png";
import trash from "../../../assets/images/icons/trash.svg";
import { coachProgramLists, coachDeleteProgram } from "../../../utils/api";
import { useLocation } from "react-router-dom";
import { useUserContext } from "../../../utils/hooks/UserContext";


function SessionsComponent() {
    const { previousPage } = useUserContext();
    console.log("herer come ", previousPage)
    const [singleSessions, setSingleSessions] = useState([]);
    const [multipleSessions, setMultipleSessions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [selectedSessionId, setSelectedSessionId] = useState(null);


    const navigate = useNavigate();
    const location = useLocation();
    const defaultTab = localStorage.getItem("selectedTab") || "first"; // Always start with 'first'
    const [selectedTab, setSelectedTab] = useState(defaultTab);


    const formatDuration = (totalMinutes) => {
        const days = Math.floor(totalMinutes / (24 * 60));
        const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
        const minutes = totalMinutes % 60;

        return [
            days > 0 ? `${days} day${days > 1 ? "s" : ""}` : "",
            hours > 0 ? `${hours} hour${hours > 1 ? "s" : ""}` : "",
            minutes > 0 ? `${minutes} min${minutes > 1 ? "s" : ""}` : ""
        ]
            .filter(Boolean) // Remove empty values
            .join(", ");
    };
    useEffect(() => {
        localStorage.setItem("selectedTab", selectedTab);
    }, [selectedTab]);




    useEffect(() => {
        if (previousPage === "/coach/sessions" || previousPage === "/coach/sessions/add-session") {
            const storedTab = localStorage.getItem("selectedTab");
            console.log("herer---->>", storedTab)
            setSelectedTab(storedTab || "first"); // Restore saved tab
        } else {
            localStorage.removeItem("selectedTab"); // Clear storage when coming from another page
            setSelectedTab("first"); // Always reset to "first"
        }
    }, [previousPage]); // ✅ Runs whenever `previousPage` changes

    useEffect(() => {
        fetchSessions();
    }, []);

    async function fetchSessions() {
        setLoading(true);
        try {
            const response = await coachProgramLists();//{"status":true,"message":"Success","data":[{"id":6,"coach_id":7,"session_title":"2","price":"100","no_of_session":"10","duration":"30","description":"","type":"single","status":"Active","created_at":"2024-08-28T07:25:00.000Z","updated_at":"2024-08-28T07:25:00.000Z"},{"id":5,"coach_id":1,"session_title":"Testing Session of Coach Shubham","price":"199","no_of_session":"3","duration":"1","description":"One on One live interaction with the coach. Ask me anything round to get frank.","type":"single","status":"Active","created_at":"2024-08-26T13:47:31.000Z","updated_at":"2024-08-26T13:47:31.000Z"},{"id":4,"coach_id":6,"session_title":"Digital Marketing Fundamentals","price":"120","no_of_session":"1","duration":"7","description":"","type":"single","status":"Active","created_at":"2024-08-24T06:57:43.000Z","updated_at":"2024-08-24T06:57:43.000Z"},{"id":3,"coach_id":5,"session_title":"Developer meet","price":"100","no_of_session":"1","duration":"6","description":"","type":"single","status":"Active","created_at":"2024-08-24T05:24:23.000Z","updated_at":"2024-08-24T05:24:23.000Z"},{"id":2,"coach_id":2,"session_title":"Negotion Skill","price":"99","no_of_session":"1","duration":"1","description":"","type":"single","status":"Active","created_at":"2024-07-29T17:27:29.000Z","updated_at":"2024-07-29T17:27:29.000Z"},{"id":1,"coach_id":2,"session_title":"Relationship Building","price":"110","no_of_session":"1","duration":"30","description":"Relationship Building1","type":"multiple","status":"Active","created_at":"2024-07-29T17:27:28.000Z","updated_at":"2025-02-05T06:18:34.000Z"}]};
            if (response.status) {
                const allSessions = response.data.data;
                setSingleSessions(allSessions.filter(session => session.type === "single"));
                setMultipleSessions(allSessions.filter(session => session.type === "multiple"));
            }
        } catch (error) {
            console.error("Error fetching sessions:", error);
            //toast.error("Error fetching sessions:", error);
        } finally {
            setLoading(false);
        }
    }

    const handleDelete = async () => {
        if (!selectedSessionId) return;

        try {
            const response = await coachDeleteProgram({ program_ids: JSON.stringify([selectedSessionId]) });

            if (response.status) {
                toast.success("Program Deleted successfully");
                fetchSessions(); // Refresh the session list after deletion
            } else {
                toast.error(response.message || "Failed to delete program.");
            }
        } catch (error) {
            console.error("Error deleting program:", error);
            toast.error("An error occurred while deleting.");
        } finally {
            setShowModal(false);
            setSelectedSessionId(null);
        }
    };

    const openDeleteModal = (id) => {
        setSelectedSessionId(id);
        setShowModal(true);
    };

    // const renderSessions = (sessions) => {
    //     return sessions.length > 0 ? (
    //         sessions.map((session) => (
    //             <div key={session.id} className="white_bg p-3 bdr-20 mb-4">
    //                 <Row className="g-2">
    //                     <Col>
    //                         <div>
    //                             <span className="fs-15 fw-400 text_brand_color1">#{session.id}</span>
    //                         </div>
    //                         <div className="d-flex justify-content-between align-items-center">
    //                             <h4 className="fs-20 fw-500 text_brand_color7 m-0">{session.session_title}</h4>
    //                             <div className="d-flex align-items-center gap-3">
    //                                 <span className="fs-15 fw-600 text_light">{session.duration} min</span>
    //                                 <span className="fs-18 fw-500 text_brand_color2">${session.price}</span>
    //                             </div>
    //                         </div>
    //                         <p className="lh-17 my-2">{session.description || "No description provided."}</p>
    //                     </Col>
    //                     <Col sm="auto">
    //                         <div>
    //                             <Button className="d-flex mb-2" variant="pencil_" onClick={() => navigate(`/coach/sessions/add-session/${session.id}`)}>
    //                                 <img width={20} src={pencil_} alt="Edit" />
    //                             </Button>
    //                             <Button className="d-flex mb-2" variant="trash_" onClick={() => openDeleteModal(session.id)}>
    //                                 <img width={20} src={trash} alt="Delete" />
    //                             </Button>
    //                         </div>
    //                     </Col>
    //                 </Row>
    //             </div>
    //         ))
    //     ) : (
    //         <p className="text-center">No sessions available.</p>
    //     );
    // };

    const handleAddSession = (item) => {
        console.log("selectedTab", selectedTab)
        navigate('/coach/sessions/add-session', { state: { selectedTab: selectedTab } });
    }
    const renderSessions = (sessions) => {
        return sessions.length > 0 ? (
            sessions.map((session) => (
                <div key={session.id} className="white_bg p-3 bdr-20 mb-4">
                    <Row className="g-2">
                        <Col>
                            <div>
                                <span className="fs-15 fw-400 text_brand_color1">#{session.id}</span>
                            </div>
                            <div className="d-flex justify-content-between align-items-center">
                                <h4 className="fs-20 fw-500 text_brand_color7 m-0">{session.session_title}</h4>
                                <div className="d-flex align-items-center gap-3">
                                    <span className="fs-15 fw-600 text_light">{session.type === 'single' ? formatDuration(session.duration) : session.duration + 'Days'}</span>
                                    <span className="fs-18 fw-500 text_brand_color2">${session.price}</span>
                                </div>
                            </div>
                            <p className="lh-17 mt-2 mb-0">{session.description || "No description provided."}</p>
                        </Col>
                        <Col sm="auto">
                            <div>
                                <Button className="d-flex mb-2" variant="pencil_" onClick={() => navigate(`/coach/sessions/add-session/${session.id}`)}>
                                    <img width={20} src={pencil_} alt="Edit" />
                                </Button>
                                <Button className="d-flex mb-2" variant="trash_" onClick={() => openDeleteModal(session.id)}>
                                    <img width={20} src={trash} alt="Delete" />
                                </Button>

                            </div>
                        </Col>
                    </Row>

                    {/* Render Nested Sessions in an Accordion if available */}
                    {session.sessions && session.sessions.length > 0 && (
                        <Accordion defaultActiveKey="0" className="mt-3">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>{session.sessions.length} Sessions</Accordion.Header>
                                <Accordion.Body>
                                    <Table className="borderless_td m-0 align-middle">
                                        <thead>
                                            <tr>
                                                <th>Session Name</th>
                                                <th className="text-end">Duration</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {session.sessions.map((subSession, index) => (
                                                <tr key={index}>
                                                    <td className="fs-14 fw-500 text_brand_color7">{subSession.name}</td>
                                                    <td className="text-end fs-14 fw-500">{formatDuration(subSession.duration)}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    )}
                </div>
            ))
        ) : (
            <p className="text-center">No sessions available.</p>
        );
    };
    return (
        <section className="sessions_pages">
            <div className="text-start hdng_a mb-3 d-flex justify-content-between">
                <h2>Sessions</h2>
            </div>

            <Tab.Container id="left-tabs-example" defaultActiveKey={selectedTab}>
                <Row>
                    <Col>
                        <div className="d-flex justify-content-between">
                            <Nav variant="pills" className="tab_btn_white" activeKey={selectedTab}
                                onSelect={(selectedKey) => setSelectedTab(selectedKey)} >
                                <Nav.Item>
                                    <Nav.Link eventKey="first">Single</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="second">Multiple</Nav.Link>
                                </Nav.Item>
                            </Nav>
                            <Button type="submit" variant="success" className="px-4" onClick={handleAddSession}>
                                Add Sessions
                            </Button>
                        </div>
                    </Col>
                    <Tab.Content className="mt-5">
                        <Tab.Pane eventKey="first">
                            {loading ? <Spinner animation="border" className="d-block mx-auto" /> : renderSessions(singleSessions)}
                        </Tab.Pane>
                        <Tab.Pane eventKey="second">
                            {loading ? <Spinner animation="border" className="d-block mx-auto" /> : renderSessions(multipleSessions)}
                        </Tab.Pane>
                    </Tab.Content>
                </Row>
            </Tab.Container>

            {/* Confirmation Modal */}
            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete this session?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
                    <Button variant="danger" onClick={handleDelete}>Delete</Button>
                </Modal.Footer>
            </Modal>



        </section>
    );
}

export default SessionsComponent;
